import React from 'react';

const Button = ({ children, onClick, type = "button" }) => {
  return (
    <button
      type={type}
      onClick={onClick}
      style={{
        width: "100%",
        maxWidth: "420px",
        height: "42px",
        backgroundColor: "#1e5aa8",
        color: "#fff",
        border: "none",
        borderRadius: "6px",
        fontSize: "15px",
        fontWeight: "500",
        letterSpacing: "0.2px",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center", // Make sure this is 'center' with a capital C
        margin: "0 auto"
      }}
    >
      {children}
    </button>
  );
};

export default Button;